module.exports = __webpack_public_path__ + "static/media/pic6.be233b0a.jpg";